<template>
  <!-- The 聊天 button (SPEC §5.6): a small speech bubble beside 形势判断; it shows or hides the chat. -->
  <button type="button" class="chat-button" :aria-pressed="String(!!pressed)" @click="$emit('click')">
    <svg viewBox="0 0 40 34" aria-hidden="true"><path d="M6 2h28a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H16l-8 7v-7H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z"/></svg>
    <span>{{ t('button-chat') }}</span>
  </button>
</template>

<script>
import { t } from '@/texts';

export default {
  name: 'ChatButton',
  props: { pressed: Boolean },
  methods: { t },
};
</script>

<style scoped>
.chat-button {
  position: relative;
  width: 64px;
  height: 52px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  vertical-align: middle;
}

.chat-button svg {
  position: absolute;
  left: 0;
  top: 0;
  width: 64px;
  height: 54px;
  fill: #fff;
  stroke: #c8b28a;
  stroke-width: 2.2;
}

.chat-button[aria-pressed="true"] svg { fill: #ffd39a; }

.chat-button span {
  position: relative;
  top: -5px;
  font-size: 14px;
  color: #2c3e50;
}
</style>
